import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-abs-savings-percentage", "data-abs-savings-amount"]
const _hoisted_2 = ["data-product_id", "data-variant_id"]
const _hoisted_3 = ["data-product_id", "data-variant_id"]
const _hoisted_4 = ["data-product_id", "data-variant_id"]
const _hoisted_5 = ["data-product_id", "data-variant_id"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.groupedBadgesByPosition, (position) => {
      return (_openBlock(), _createElementBlock("div", {
        key: position.name,
        class: _normalizeClass(["z-1 absolute flex flex-col gap-y-8 text-center text-12 font-medium text-white", $options.positionClasses[position.name]?.[$props.margin]])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.badges, (badge) => {
          return (_openBlock(), _createElementBlock("span", {
            key: badge.key,
            class: _normalizeClass(["badge badge-small badge-rounded", [_ctx.$attrs.class, badge.class]]),
            style: _normalizeStyle(badge.style),
            "data-abs-savings-percentage": badge.discountType === 'percentage' ? '' : null,
            "data-abs-savings-amount": badge.discountType === 'amount' ? '' : null
          }, _toDisplayString(badge.text), 15, _hoisted_1))
        }), 128)),
        (
        $data.enableWishlist &&
        position.name === $data.wishlistCollectionPosition &&
        $props.product.id &&
        !$props.isProductPage
      )
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["wishlist-engine", $options.wishlistAlignmentClass]),
              "data-product_id": $props.product.id,
              "data-variant_id": $props.product.first_available_variant_id,
              "data-full_button": "true"
            }, null, 10, _hoisted_2))
          : _createCommentVNode("", true),
        ($data.enableWishlist && position.name === $data.wishlistPdpPosition && $props.product.id && $props.isProductPage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["wishlist-engine", $options.wishlistAlignmentClass]),
              "data-product_id": $props.product.id,
              "data-variant_id": $props.product.first_available_variant_id,
              "data-full_button": "false"
            }, null, 10, _hoisted_3))
          : _createCommentVNode("", true)
      ], 2))
    }), 128)),
    ($data.enableWishlist && $props.product.id && !$options.hasBadgesAtCollectionWishlistPosition && !$props.isProductPage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["wishlist-engine z-1 absolute", $options.positionClasses[$data.wishlistCollectionPosition]?.[$props.margin]]),
          "data-product_id": $props.product.id,
          "data-variant_id": $props.product.first_available_variant_id,
          "data-full_button": "true"
        }, null, 10, _hoisted_4))
      : _createCommentVNode("", true),
    ($data.enableWishlist && $props.product.id && !$options.hasBadgesAtPdpWishlistPosition && $props.isProductPage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["wishlist-engine z-1 absolute", $options.positionClasses[$data.wishlistPdpPosition]?.[$props.margin]]),
          "data-product_id": $props.product.id,
          "data-variant_id": $props.product.first_available_variant_id,
          "data-full_button": "false",
          "data-css": "true"
        }, null, 10, _hoisted_5))
      : _createCommentVNode("", true)
  ], 64))
}